import React from 'react';
import { Box, Card, Skeleton } from 'minimal-ui';

const LoadingSkeleton = () => {
    return (
        <Box sx={{
            display: 'flex',
            flexDirection: 'column',
            height: '100%',
            backgroundColor: 'white'
        }}>
            <Box sx={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                p: 2,
                borderBottom: '1px solid #E0E0E0',
                flexShrink: 0
            }}>
                <Box display="flex" alignItems="center" gap={2}>
                    <Skeleton variant="circular" width={40} height={40} />
                    <Skeleton variant="text" width={150} height={24} />
                </Box>
                <Skeleton variant="circular" width={40} height={40} />
            </Box>

            <Box sx={{ p: 2, flexShrink: 0 }}>
                <Skeleton variant="text" width="80%" height={32} sx={{ mb: 1 }} />
                <Skeleton variant="text" width="100%" height={20} sx={{ mb: 1 }} />
                <Skeleton variant="text" width="90%" height={20} sx={{ mb: 1 }} />
                <Skeleton variant="text" width="70%" height={20} />
            </Box>

            <Box sx={{ px: 2, flexShrink: 0 }}>
                <Box sx={{ display: 'flex', gap: 2 }}>
                    <Skeleton variant="rectangular" width={120} height={48} sx={{ borderRadius: '8px' }} />
                    <Skeleton variant="rectangular" width={120} height={48} sx={{ borderRadius: '8px' }} />
                </Box>
            </Box>

            <Box sx={{ p: 2, flexShrink: 0 }}>
                <Skeleton variant="rectangular" height={56} sx={{ borderRadius: '8px' }} />
            </Box>

            <Box sx={{ px: 2, flexShrink: 0 }}>
                <Skeleton variant="text" width={120} height={20} />
            </Box>

            <Box sx={{
                flex: 1,
                overflowY: 'auto',
                p: 2,
                pt: 1
            }}>
                {Array.from({ length: 4 }).map((_, index) => (
                    <Card key={index} sx={{
                        p: 2,
                        borderRadius: '10px',
                        mb: 2,
                        border: '1px solid #E0E0E0'
                    }}>
                        <Box display="flex" gap={2} alignItems="flex-start">
                            <Skeleton variant="rectangular" width={60} height={60} sx={{ borderRadius: '7px' }} />
                            <Box flex={1}>
                                <Skeleton variant="text" width="85%" height={20} sx={{ mb: 1 }} />
                                <Box display="flex" alignItems="center" gap={1} mb={1}>
                                    <Skeleton variant="rectangular" width={50} height={24} sx={{ borderRadius: '3px' }} />
                                    <Skeleton variant="text" width={80} height={16} />
                                    <Skeleton variant="text" width={10} height={16} />
                                    <Skeleton variant="text" width={60} height={16} />
                                </Box>
                                <Box display="flex" alignItems="center" gap={1} mb={1}>
                                    <Skeleton variant="text" width={60} height={16} />
                                    <Skeleton variant="text" width={50} height={16} />
                                </Box>
                            </Box>
                            <Box display="flex" flexDirection="column" alignItems="flex-end" gap={1}>
                                <Skeleton variant="rectangular" width={100} height={40} sx={{ borderRadius: '8px' }} />
                                <Skeleton variant="rectangular" width={100} height={32} sx={{ borderRadius: '8px' }} />
                            </Box>
                        </Box>
                    </Card>
                ))}
            </Box>
        </Box>
    );
};

export default LoadingSkeleton;

